<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item.name}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <!-- <div class="metter">
            <div class="nav" v-for="item in 8" :key="item">
                <div class="navfirst">刑侦科春季新入职民警培训班（一期）</div>
                <div class="navsecond">
                    <div>调训方式：线上调训</div>
                    <div>调训时间：2020.06.20 至 2020.06.30</div>
                    <div>培训班类别：新警入职培训</div>
                    <div>培训手册：刑侦科春季新警入职培训手册.doc</div>
                </div>
                <div class="navthirt">
                    <el-button type="primary" plain size="small">详情</el-button>
                    <el-button type="primary" plain size="small">培训班课程</el-button>
                    <el-button type="primary" plain size="small">培训班考试</el-button>
                    <el-button type="primary" plain size="small">免训申请</el-button>
                    <el-button type="primary" plain size="small">培训班成绩</el-button>
                </div>
            </div>
        </div>
        <div class="pagination">
                <el-pagination
                    background
                    prev-text="上一页"
                    next-text="下一页"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage2"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    layout="total,sizes, prev, pager, next"
                    :total="1000">
                </el-pagination>
    </div>-->
    <div class="metter" v-if="trainData.length!==0">
      <div class="nav" v-for="(item,index) in trainData" :key="index">
        <div class="navfirst">
          <div>{{item.title}}</div>
          <div>
            <el-tag type="danger" style="margin-right:20px">准入测试</el-tag>
            <el-tag type="danger">未报送</el-tag>
          </div>
        </div>
        <div class="navsecond">
          <div>
            调训方式：
            <span v-if="item.createType==1">线下调训</span>
            <span v-if="item.createType==2">线上调训</span>
          </div>
          <div>调训时间：{{item.starTime}} 至 {{item.endTime}}</div>
          <div>培训班类别：{{item.cateDicName}}</div>
          <div>培训状态：{{item.stateName}}</div>
        </div>
        <div class="navthirt">
          <el-button type="primary" plain size="small" @click="trainclass(item.id)">详情</el-button>
          <el-button type="primary" plain size="small">培训班课程</el-button>
          <el-button type="primary" plain size="small">培训班考试</el-button>
          <el-button type="primary" plain size="small" @click="mianxun(item.id)">免训申请</el-button>
          <el-button type="primary" plain size="small">培训班成绩</el-button>
        </div>
      </div>
    </div>
    <div v-else style="margin-top:120px">
      <nodata></nodata>
    </div>
    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total,sizes, prev, pager, next"
        :total="trainCount"
      ></el-pagination>
    </div>
    <el-dialog title="免训申请" :visible.sync="dialogVisiblemianxun" width="30%">
      <el-form ref="mianxunform" label-position="right" label-width="100px" :model="mianxunform">
        <el-form-item label="免训理由">
          <el-input v-model="mianxunform.descript" style="width:400px" type="textarea"></el-input>
        </el-form-item>
        <div style="text-align:center">
          <el-button type="primary" @click="submitMianxun" size="small">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import * as Personcenter from '@/api/personcenter/index';
export default {
  data() {
    return {
      dialogVisiblemianxun: false,
      labledata: [{ name: '进行中的培训', id: 1 }],
      currentPage2: 1,
      listQuery: {
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
        type: 2,
      },
      lableindex: 0,
      trainData: [],
      trainCount: 0,
      mianxunform: {
        descript: '',
      },
    };
  },
  created() {
    this.getListTrain();
  },
  methods: {
    mianxun(id) {
      this.dialogVisiblemianxun = true;
    },
    lableArea(index, item) {
      this.lableindex = index;
      this.listQuery.type = item.id;
      this.getListTrain();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getListTrain();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getListTrain();
    },
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    getListTrain() {
      Personcenter.TrainInfoGetMyTrain(this.listQuery).then((res) => {
        this.trainData = res.data;
        this.trainData.forEach((item) => {
          item.starTime = item.starTime.slice(0, 10);
          item.endTime = item.endTime.slice(0, 10);
        });
        this.trainCount = res.count;
      });
    },
    submitMianxun() {},
  },
};
</script>
<style scoped>
.content {
  width: 900px;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  width: 850px;
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 150px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 140px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.metter {
  display: flex;
  flex-wrap: wrap;
}

.nav {
  width: 800px;
  height: 190px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  /* border-style: solid;
    border-color: rgba(255, 255, 255, 1);
    box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */
  border: 1px solid #f2f2f2;
  /* padding-left: 16px; */
  padding-top: 16px;
  margin-left: 20px;
}
/* .nav:hover{
    box-shadow:  2px 2px 5px rgba(52, 194, 250, 0.969)!important
} */
.navfirst {
  font-weight: 700;
  padding: 0 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}
hr {
  margin-top: 10px;
}
.navsecond {
  height: 80x;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #f2f2f2;
}
.navsecond > div {
  line-height: 50px;
  width: 370px;
  /* text-align: center; */
  padding-left: 20px;
  color: #7f7f7f;
  font-size: 14px;
}
.navthirt {
  height: 50px;
  padding-top: 7px;
  padding-bottom: 5px;
  /* text-align: center; */
  padding-left: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>